import {
    GridFiltersState,
    IEncodedParams,
    IGridUrlParams,
} from '@pages/generics/grid/state-handlers';
import { encodeParams } from '@utils/encode.utils';

export const encodeFilters = (filters: GridFiltersState): IGridUrlParams => ({
    state: encodeParams<IEncodedParams>({ filters }),
});
